module.exports = __webpack_public_path__ + "static/media/vengefulspirit.dcbbdbce.png";